import { defineStore } from "pinia";
import {
  type boughtProductsT,
  type entry,
  type fireExtinguisherCheckT,
  type Product,
} from "@/types";
import type FilePickerAcceptType from "wicg-file-system-access";
const STORE_NAME = "FireExtinguisherCheck";

const jsonFileType: FilePickerAcceptType = {
  description: "Json File",
  accept: { "text/json": [".json", ".JSON"] },
};

const getData = () => {
  console.log("called getData");
  const data = localStorage.getItem(STORE_NAME);

  const parsed = JSON.parse(data!);
  if (data) {
    console.log("found data");
    parsed.date = new Date(parsed.date);
    for (const entry of parsed.entries) {
      entry.billed = new Date(entry.billed);
      entry.paid = new Date(entry.paid);
    }
  }
  console.log("parsed data:", parsed);

  return {
    date: new Date(),
    lastEntryId: 0,
    entries: [],
    lastProductId: 0,
    products: [],
    prices: { check: 10, refill: 60, disposeFoam: 18, disposePowder6: 20, disposePowder12: 30 },
    ...parsed,
  } as {
    date: Date;
    lastEntryId: number;
    entries: entry[];
    lastProductId: number;
    products: Product[];
    prices: {
      check: number;
      refill: number;
      disposeFoam: number;
      disposePowder6: number;
      disposePowder12: number;
    };
  };
};

export const useStore = defineStore(STORE_NAME, {
  state: () => getData(),
  actions: {
    update() {
      localStorage.setItem(STORE_NAME, JSON.stringify(this.$state));
      console.log("saved to LS");
    },
    createEntry() {
      this.lastEntryId++;
      const newEntry = {
        id: "" + this.lastEntryId,
        Customer: { salutation: "", name: "", street: "", city: "" },
        fireExtinguisherCheck: {
          checked: 0,
          refilled: 0,
          passed: 0,
          disposedFoam: 0,
          disposedPowder6: 0,
          disposedPowder12: 0,
        },
        boughtProducts: [],
        billed: new Date(0),
        paid: new Date(0),
        notes: "",
      } as entry;
      this.entries.push(newEntry);

      this.update();
      return newEntry;
    },
    createProduct() {
      this.lastProductId++;
      this.products.push({ id: "" + this.lastProductId, name: "", price: 1 });
      this.update();
    },
    getSum(fec: fireExtinguisherCheckT) {
      return (
        fec.checked * this.prices.check +
        fec.refilled * this.prices.refill +
        fec.disposedFoam * this.prices.disposeFoam +
        fec.disposedPowder6 * this.prices.disposePowder6 +
        fec.disposedPowder12 * this.prices.disposePowder12
      );
    },
    getProductSum(bps: boughtProductsT[]) {
      let sum = 0;
      for (const product of bps) {
        sum += this.products.find((x) => x.id == product.id)!.price * product.count;
      }
      return sum;
    },
    async saveFile() {
      console.log("save");

      const FileHandle = await window.showSaveFilePicker({
        suggestedName:
          "FFE_loescherueberpruefung_" + this.date.toISOString().substring(0, 10) + ".json",
        types: [jsonFileType],
      });
      const writable = await FileHandle.createWritable();
      await writable.write(JSON.stringify(this.$state));
      await writable.close();
    },
    async loadFile() {
      console.log("load");
      const [FileHandle] = await window.showOpenFilePicker({
        multiple: false,
        types: [jsonFileType],
      });
      const file = await FileHandle.getFile();
      const content = await file.text();

      console.log(content);

      localStorage.setItem(STORE_NAME, content);

      location.reload();
    },
  },
});
